import React from 'react';
import { 
  TextField, 
  Grid, 
  IconButton, 
  Button,
  Switch,
  FormControlLabel 
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import styled from 'styled-components';
import { formatDate } from '../../../utils/dateFormat';

const FormContainer = styled.div`
  padding: 1rem;
`;

const EducationItem = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #eee;
  border-radius: 4px;
  position: relative;
`;

const DeleteButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

const DateField = styled(TextField)`
// 控制Chrome、Safari 等 WebKit 内核的浏览器
  input::-webkit-calendar-picker-indicator {
  // 隐藏日历图标
    display: none;
  }
`;

const EducationForm = ({ data = [], onChange }) => {
  const handleAdd = () => {
    onChange([...data, {
      school: '',
      degree: '',
      field: '',
      startDate: new Date().toISOString().slice(0, 7),
      endDate: new Date().toISOString().slice(0, 7),
      gpa: '',
      courses: [],
      showGpa: false,
      showCourses: false
    }]);
  };

  const handleDelete = (index) => {
    const newData = data.filter((_, i) => i !== index);
    onChange(newData);
  };

  const handleChange = (index, field) => (event) => {
    const newData = [...data];
    const value = field.includes('Date') 
      ? event.target.value || new Date().toISOString().slice(0, 7)
      : event.target.value;
    
    newData[index] = {
      ...newData[index],
      [field]: value
    };
    onChange(newData);
  };

  const handleToggle = (index, field) => () => {
    const newData = [...data];
    newData[index] = {
      ...newData[index],
      [field]: !newData[index][field]
    };
    onChange(newData);
  };

  const handleCoursesChange = (index) => (event) => {
    const newData = [...data];
    newData[index] = {
      ...newData[index],
      courses: event.target.value.split(',').map(course => course.trim())
    };
    onChange(newData);
  };

  return (
    <FormContainer>
      {data.map((edu, index) => (
        <EducationItem key={index}>
          <DeleteButton onClick={() => handleDelete(index)}>
            <DeleteIcon />
          </DeleteButton>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="学校"
                value={edu.school}
                onChange={handleChange(index, 'school')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="学位"
                value={edu.degree}
                onChange={handleChange(index, 'degree')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="专业"
                value={edu.field}
                onChange={handleChange(index, 'field')}
              />
            </Grid>
            <Grid item xs={6}>
              <DateField
                fullWidth
                label="开始日期"
                type="month"
                value={formatDate(edu.startDate) || ''}
                onChange={handleChange(index, 'startDate')}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: "1900-01",
                  max: "2100-12"
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <DateField
                fullWidth
                label="结束日期"
                type="month"
                value={formatDate(edu.endDate) || ''}
                onChange={handleChange(index, 'endDate')}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: "1900-01",
                  max: "2100-12"
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} style={{ marginTop: '1rem' }}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={edu.showGpa || false}
                    onChange={handleToggle(index, 'showGpa')}
                  />
                }
                label="添加专业成绩"
              />
            </Grid>
            
            {edu.showGpa && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="专业成绩 (GPA)"
                  value={edu.gpa || ''}
                  onChange={handleChange(index, 'gpa')}
                  placeholder="例如: 3.8/4.0"
                />
              </Grid>
            )}
            
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={edu.showCourses || false}
                    onChange={handleToggle(index, 'showCourses')}
                  />
                }
                label="添加主修课程"
              />
            </Grid>
            
            {edu.showCourses && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="主修课程"
                  value={edu.courses?.join(', ') || ''}
                  onChange={handleCoursesChange(index)}
                  multiline
                  rows={2}
                  placeholder="用逗号分隔课程名称，例如: 数据结构, 算法分析, 计算机网络"
                  helperText="输入课程名称，用逗号分隔"
                />
              </Grid>
            )}
          </Grid>
        </EducationItem>
      ))}
      <Button
        startIcon={<AddIcon />}
        onClick={handleAdd}
        variant="outlined"
        color="primary"
        fullWidth
      >
        添加教育经历
      </Button>
    </FormContainer>
  );
};

export default EducationForm; 